import React from "react";
import _ from "lodash";

import DashboardTable from "../../../../../../../components/DashboardTable/DashboardTable";
import RiskScoreConfirmationModal from "../../../../../../RiskProfiling/components/StepContent/components/step/ProductsSelectionSteps/components/InvestmentRecommendationStep/components/RiskScoreConfirmationModal/RiskScoreConfimrationModal";
import { RiskScoreConfirmationModalContext } from "../../../../../../RiskProfiling/components/StepContent/components/step/ProductsSelectionSteps/components/InvestmentRecommendationStep/InvestmentRecommendationStep";

import usePaymentPlanEdit from "../../SavingsPlansTrade/hooks/usePaymentPlanEdit";
import { getPayoutPlansTableStructure } from "../../SavingsPlansTrade/table/columns";
import AddInstrumentDialog from "../../SavingsPlansTrade/components/AddInstrumentDialog";
import { getPaymentPlanMaxStartDate, TRANSACTION_TYPE_VALUES } from "../../../../../constants";
import { usePaymentPlanTableStyles } from "../../shared/paymentPlanTableStyles";
import EmptyTableMessage from "../../../../../../RiskProfiling/components/EmptyTableMessage";
import { useMPSummaryLine } from "../../shared/mpSummaryLine";

const PayoutPlanTable = ({
  portfolio,
  allInstruments,
  portfolioComponents,
  onInstrumentsChange,
  customerId,
  action,
  paymentPlanTransactionKey,
  groupInstruments,
  defaults,
  updateDefaults,
  dataService,
  isVirtual,
  isCustomerApp,
}) => {
  const classes = usePaymentPlanTableStyles();

  const {
    dialogOpen,
    setDialogOpen,
    loading,
    instrumentsHandlers,
    confirmRiskModalState,
    isAnlageberatung,
    handleAmountChange,
    handleDiscountChange,
    handlePlanDataChange,
    handleAddItems,
    handleAddSavingPlanButtonClick,
    onRemoveClick,
    onRemoveAllClick,
    handleConfirmRiskModalSave,
    handleSelectAsset,
  } = usePaymentPlanEdit({
    portfolio,
    allInstruments,
    onInstrumentsChange,
    customerId,
    action,
    groupInstruments,
    defaults,
    updateDefaults,
    dataService,
    transactionType: TRANSACTION_TYPE_VALUES.PAYOUT_PLAN,
    isVirtual,
  });

  const tableStructure = React.useMemo(
    () => getPayoutPlansTableStructure(portfolio.isModelportfolio),
  [portfolio.isModelportfolio]
  )

  const { dataSource, expandSummaryLineChange, checkExpanded } = useMPSummaryLine(portfolio, groupInstruments || []);
  const selectPlanTitle = action === "create" ? undefined : "Entnahmeplan auswählen";

  return (
    <RiskScoreConfirmationModalContext.Provider
      value={{
        open: confirmRiskModalState.open,
        activeAsset: confirmRiskModalState.activeAsset,
        onSave: handleConfirmRiskModalSave,
        onSelectAsset: handleSelectAsset,
        singleInvestmentEnabled: _.isEmpty(portfolio.transactions.payout_plan),
      }}
    >
      <div className={classes.tableContainer}>
        <DashboardTable
          tableLayout="auto"
          dataSource={dataSource}
          structure={tableStructure}
          tableClasses={classes}
          emptyDataMessage={<EmptyTableMessage isMPorPI={portfolio.isModelportfolio} />}
          withFooter
          expanded
          withInputs
          options={{
            isVirtual,
            expandSummaryLineChange,
            checkExpanded,
            paymentPlanTransactionKey,
            availableDiscounts: portfolio.availableDiscounts,
            rotationOptions: portfolio.isModelportfolio
              ? portfolio.availableMPPayoutPlanPeriodicPlans
              : portfolio.availablePayoutPlanPeriodicPlans,
            fromDateOptions: portfolio.isModelportfolio
              ? portfolio.availableMPPayoutPlanExecutionDates
              : portfolio.availablePayoutPlanExecutionDates,
            handleDiscountChange,
            handlePlanDataChange,
            handleAmountChange,
            handleRemoveClick: onRemoveClick,
            onRemoveAllClick,
            isModelportfolio: portfolio.isModelportfolio,
            isAnlageberatung,
            clientSRRI: dataService.srri,
            tillDateEnabled: portfolio.ordering_payout_plan_till_date_enabled,
            deleteDateEnabled: portfolio.ordering_payout_plan_delete_date_enabled,
            maxStartDate: (item) => getPaymentPlanMaxStartDate(item, portfolio, action),
            handleAddClick: () => handleAddSavingPlanButtonClick(action),
            addButtonText: selectPlanTitle,
          }}
        />
      </div>

      <AddInstrumentDialog
        open={dialogOpen}
        title={selectPlanTitle}
        onClose={() => setDialogOpen(false)}
        portfolio={portfolio}
        portfolioComponents={portfolioComponents}
        allInstruments={allInstruments}
        instrumentsHandler={instrumentsHandlers[action]}
        handleAddItems={handleAddItems}
        action={action}
        withSrri={isAnlageberatung}
        clientSRRI={dataService.srri}
        customerId={customerId}
        isCustomerApp={isCustomerApp}
        isVirtual={isVirtual}
        portfolioOnly
      />

      <RiskScoreConfirmationModal />
    </RiskScoreConfirmationModalContext.Provider>
  );
};

export default PayoutPlanTable;
